import 'babel-polyfill'
import 'whatwg-fetch'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.less'
import App from './App'
import { ConfigProvider, Spin } from 'antd'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import zhCN from 'antd/es/locale/zh_CN'
import store from './redux/store'
import { persistor } from './redux/store'
import { PersistGate } from 'redux-persist/lib/integration/react'

import { SpinLoading } from './components'
import * as Sentry from '@sentry/react'
const pkgJson = require('../package.json')

Sentry.init({
	dsn: 'https://edf3e40196d653cade561087b5e46f8a@sentry.inf.17usoft.com/344',
	release: `fe-cdc@${pkgJson.version}`,
	environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
	integrations: [
		Sentry.browserTracingIntegration({
			tracePropagationTargets: ['localhost', 'da.elong.com', 'https://da.elong.com'],
		}),
		Sentry.replayIntegration(),
	],
	tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
})

Spin.setDefaultIndicator(<SpinLoading />)

Array.prototype.indexOf = function (val) {
	for (let i = 0; i < this.length; i++) {
		if (this[i] == val) return i
	}
	return -1
}
Array.prototype.remove = function (val) {
	let index = this.indexOf(val)
	if (index > -1) {
		this.splice(index, 1)
	}
}
ReactDOM.render(
	// 默认语言为中文
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ConfigProvider locale={zhCN}>
				<App />
			</ConfigProvider>
		</PersistGate>
	</Provider>,
	document.getElementById('root'),
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
